import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Popup from "./Popup";
import { Btn } from "../../styles/Button.styled";
import { Container } from "../../styles/Sidebar/UploadModal.styled";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { cancelDoc, CANCEL_RESET } from "../../actions/cancel";

interface CancelDocPopupProps {
  docId: string;
  onClose: () => void;
}

export function CancelDocPopup({ docId, onClose }: CancelDocPopupProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const cancelState = useAppSelector((state: any) => state.cancelDoc);

  useEffect(() => {
    if (!submitted) return;
    if (cancelState.state === "success") {
      navigate("/documents/all");
    } else if (cancelState.state === "failure") {
      onClose();
    }
  }, [cancelState.state, submitted]);

  const handleConfirm = () => {
    dispatch({ type: CANCEL_RESET });
    setSubmitted(true);
    dispatch(cancelDoc(docId, comment));
  };

  const loading = submitted && cancelState.state === "loading";

  return (
    <Popup clickCloseButton={onClose} style={{ height: "max-content" }}>
      <h1>Скасування документу</h1>
      <Container>
        <div style={{ marginBottom: "16px" }}>
          <p style={{ fontSize: "14px", color: "var(--text-main, #333)", marginBottom: "10px" }}>
            Вкажіть причину скасування:
          </p>
          <div style={{ position: "relative" }}>
            <style>{`.cancel-textarea::placeholder { color: var(--cadetGrey); }`}</style>
            <textarea
              className="cancel-textarea"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Введіть коментар..."
              rows={4}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid var(--background-gray)",
                fontSize: "14px",
                fontFamily: "inherit",
                resize: "vertical",
                boxSizing: "border-box",
              }}
            />
            {/* <span style={{ position: "absolute", bottom: "8px", right: "10px", fontSize: "11px", color: "var(--cadetGrey)", pointerEvents: "none" }}>
              {comment.length} з 10
            </span> */}
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--blue)"
            $marginTop="0"
            style={{ flex: 1 }}
            onClick={onClose}
            $background="var(--sidebar-hover)"
            $heightMobile="47px"
            disabled={loading}
          >
            Відмінити
          </Btn>
          <Btn
            type="button"
            $width="100%"
            $color="var(--white)"
            $marginTop="0"
            style={{ flex: 1 }}
            onClick={handleConfirm}
            $background="var(--vivid-pink)"
            $heightMobile="47px"
            disabled={loading}
          >
            {loading ? "..." : "Скасувати"}
          </Btn>
        </div>
      </Container>
    </Popup>
  );
}
